import { useEffect, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import back_app from '../../lib/back_app'
import Org_select from '../../components/auth/org_select'

export default function Waitlist() {
  let { logout } = useAuth0()
  let [joined, joined_set] = useState(false)
  let [submitting, submitting_set] = useState(false)
  let [err, err_set] = useState<string | null>(null)

  useEffect(()=>{
    let cancelled = false
    back_app.org_get().then((org: any)=>{
      if (cancelled)
        return
      if (org?.flag?.is_waitlist)
        joined_set(true)
    })
    return ()=>{ cancelled = true }
  }, [])

  let on_join = async ()=>{
    submitting_set(true)
    err_set(null)
    try {
      let res = await back_app.org_set('flag.is_waitlist', true)
      if (res?.err) {
        err_set(res.err)
        return
      }
      joined_set(true)
    } catch(e: any) {
      err_set(e?.message || 'failed')
    } finally {
      submitting_set(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-blue via-primary-purple to-primary-blue flex items-center justify-center px-4 py-8">
      <div className="max-w-lg w-full bg-white/95 backdrop-blur-lg rounded-3xl shadow-2xl p-8 text-center">
        <Org_select />
        <div className="text-5xl mb-4">⏳</div>
        <h1 className="text-3xl font-bold text-gray-900 mb-3">
          {joined ? "You're on the list" : 'Join the waiting list'}
        </h1>
        {joined ? (
          <p className="text-gray-600 mb-6">
            Thanks! We've added you to the waiting list. We'll email you as soon
            as your account is ready.
          </p>
        ) : (
          <p className="text-gray-600 mb-6">
            Sponly is currently invite-only. Join the waiting list and we'll let
            you in as soon as a spot opens up.
          </p>
        )}
        <button
          onClick={on_join}
          disabled={submitting || joined}
          className="w-full bg-gradient-to-r from-[#0066FF] to-[#6B4DE6] text-white py-4 rounded-xl font-bold text-lg hover:shadow-xl transition-all disabled:opacity-60"
        >
          {joined ? 'On the waiting list' : submitting ? 'Joining...' : 'Join waiting list'}
        </button>
        {err && <p className="text-red-600 text-sm mt-3">{err}</p>}
        <button
          onClick={()=>logout({logoutParams: {returnTo: window.location.origin}})}
          className="mt-6 w-full text-sm text-gray-500 hover:text-gray-700 underline"
        >
          Sign out
        </button>
      </div>
    </div>
  )
}